import makeCrud from '@/store/site/localization/crud'

// Sağlayıcı hesapları (stream/provider/account). Liste ?provider_id ile filtrelenir.
// CRUD: {provider_id, title, credentials:{...}, active}. credentials, sağlayıcının
// account_credentials_layout şemasına göre dinamiktir.
export default makeCrud('stream_provider_account')
